<template>
    <div class="container">
        <div>
            <div class="content" v-watermark>
                <div class="header">
                    <div class="title">
                        <span class="bold">基本信息</span>
                        <span class="desc" v-if="data.isMainland === 0">（非中国大陆用户）</span>
                    </div>
                    <div class="btn">
                        <van-button type="info" size="mini" @click="
                            $router.push(
                                `/patientInfo/edit?age=${data.age}&memberId=${userMemberHealth.userMemberId}&userNo=${userMemberHealth.userNo}`
                            )
                        ">编辑档案信息</van-button>
                    </div>
                </div>
                <van-row>
                    <van-col span="10">
                        <span>姓名</span>
                        <span>{{ data.name }}</span>
                    </van-col>
                    <van-col span="14">
                        <span>年龄</span>
                        <span>{{ data.age }}岁</span>
                    </van-col>
                    <van-col span="10">
                        <span>性别</span>
                        <span>{{ data.sex | sexFilter }}</span>
                    </van-col>
                    <van-col span="14">
                        <span>手机号</span>
                        <span>{{ data.mobile }}</span>
                    </van-col>
                    <van-col span="10">
                        <span>关系</span>
                        <span>{{ data.relation | relationFilter(data.relation) }}</span>
                    </van-col>
                    <van-col span="14">
                        <span>城市</span>
                        <span>{{ data.province }} {{ data.city }}</span>
                    </van-col>
                    <van-col span="24">
                        <span>{{data.isMainland === 0 ? '有效证件号' : '身份证号'}}</span>
                        <span>{{ data.idCardHide }}</span>
                    </van-col>
                    <van-col span="24" v-if="data.isMainland === 0" style="display: flex;">
                        <span>有效证件</span>
                        <span style="vertical-align: top; margin-left: -15px; flex: 1; display: flex;">
                            <van-image :src="itm" style="width: 100%; height: 90px; margin-left: 15px;" v-for="(itm, idx) in [data.idCardFront, data.idCardBack]" :key="idx" @click="onIdCardPreview([data.idCardFront, data.idCardBack], idx)" />
                        </span>
                    </van-col>
                </van-row>
                <van-field v-model="remarks" rows="3" autosize label="备注" type="textarea" placeholder="请输入备注"
                    show-word-limit />
                <div class="footer">
                    <van-button type="info" size="mini" @click="updatePatientDetails">保存备注</van-button>
                </div>
            </div>
            <div class="content" v-watermark>
                <div class="header">健康档案</div>
                <div v-if="data.userMemberHealth">
                    <van-row>
                        <van-col span="9"><span>生育史</span></van-col>
                        <van-col span="15">{{ data.userMemberHealth.maritalStatus }}，{{
                            data.userMemberHealth.maternityStatus
                        }}</van-col>
                    </van-row>
                    <van-row>
                        <van-col span="9"><span>疾病史</span></van-col>
                        <van-col span="15">{{
                            data.userMemberHealth.diseaseHistory
                        }}</van-col>
                    </van-row>
                    <van-row>
                        <van-col span="9"><span>手术史或外伤史</span></van-col>
                        <van-col span="15">{{ data.userMemberHealth.operation }}</van-col>
                    </van-row>
                    <van-row>
                        <van-col span="9"><span>家族病史</span></van-col>
                        <van-col span="15">{{
                            data.userMemberHealth.familyHistory
                        }}</van-col>
                    </van-row>
                    <van-row>
                        <van-col span="9"><span>药物过敏</span></van-col>
                        <van-col span="15">{{ data.userMemberHealth.drugAllergy }}</van-col>
                    </van-row>
                    <van-row>
                        <van-col span="9"><span>食物或接触物过敏</span></van-col>
                        <van-col span="15">{{ data.userMemberHealth.foodAllergy }}</van-col>
                    </van-row>
                    <van-row v-if="data.sex == 0">
                        <van-col span="9"><span>月经史</span></van-col>
                        <van-col span="15">{{ data.userMemberHealth.menstrualHistory }}</van-col>
                    </van-row>
                    <van-row>
                        <van-col span="9"><span>辅助检查史</span></van-col>
                        <van-col span="15">{{ data.userMemberHealth.auxiliaryExamination }}</van-col>
                    </van-row>
                    <!-- <van-row>
                        <van-col span="9"><span>个人习惯</span></van-col>
                        <van-col span="15">{{ data.userMemberHealth.habit }}</van-col>
                    </van-row> -->
                </div>
                <van-empty description="暂无健康档案" v-else />
            </div>
        </div>
        <prev-page :text="'返回首页'" @back="back"></prev-page>
    </div>
</template>
<script>
import { getPatientDetails, updatePatientDetails } from "../../api/index.js";
import { Dialog } from "vant";
import { api as viewerApi } from "v-viewer";
export default {
    data() {
        return {
            remarks: "",
            id: "",
            data: {},
            remarksText: "",
            userNo: "",
            userMemberHealth: {},
        };
    },
    created() {
        this.id = this.$route.query.id;
        this.getPatientDetails();
    },
    methods: {
        onIdCardPreview(arr, index) {
            viewerApi({
				options: {
					toolbar: true,
					initialViewIndex: index || 0,
					zIndex: 9999,
					zoomRatio: 0.5,
					title: false,
				},
				images: arr,
			});
        },
        getPatientDetails() {
            getPatientDetails({ id: this.id }).then((res) => {
                if (res.code == 0) {
                    this.data = res.data;
                    this.remarks = res.data.remarks;
                    this.remarksText = res.data.remarks;
                    this.userMemberHealth = res.data.userMemberHealth;
                }
            });
        },
        updatePatientDetails() {
            const data = {
                remarks: this.remarks,
                id: this.id,
            };
            updatePatientDetails(data).then((res) => {
                if (res.code == 0) {
                    this.$toast.success("修改备注成功");
                    this.remarksText = this.remarks;
                }
            });
        },
        back() {
            if (this.remarksText == this.remarks) {
                this.$router.back();
            } else {
                Dialog.confirm({
                    title: "提示",
                    message: "尚未保存，未保存的修改将不做保留，是否继续返回首页",
                    confirmButtonText: "是",
                    cancelButtonText: "否",
                })
                    .then(() => {
                        // on confirm
                        this.$router.back();
                    })
                    .catch(() => {
                        // on cancel
                    });
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.container {
    padding: 10px;
    padding-bottom: 90px;

    .content {
        background: #fff;
        padding: 0 26px;
        border-radius: 4px;
        margin-bottom: 10px;

        &:last-child {
            padding-bottom: 12px;
        }

        .header {
            padding: 22px 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .title {
                display: flex;
                align-items: center;
                .bold {
                    font-size: 18px;
                    font-weight: bold;
                    color: #333;
                }
                .desc {
                    color: #ee9e2e;
                    margin-left: 5px;
                    font-size: 14px;
                }
            }
        }

        :deep() .van-col {
            font-size: 14px;
            margin-bottom: 14px;

            span {
                &:first-child {
                    color: #999;
                    margin-right: 20px;
                }
            }
        }

        :deep() .van-cell {
            padding: 0;
            font-size: 14px;

            .van-cell__title {
                margin-right: 20px;
                width: auto;
            }

            .van-cell__value {
                background: #f6fbff;
                padding: 0 10px;
            }

            &::after {
                border: none;
            }
        }

        .footer {
            display: flex;
            justify-content: flex-end;
            padding: 20px 0 26px 0;
        }
    }
}

// .van-row {
//     display: flex;
//     flex-direction: column;
// }
</style>
